import api from "./api";

export const getSystemHealthData = async () => {
    const [logsRes, iotRes, blockchainRes] = await Promise.allSettled([
        api.get("/SystemLog"),
        api.get("/IoTDevice"),
        api.get("/BlockchainLog"),
    ]);

    const logs =
        logsRes.status === "fulfilled" && Array.isArray(logsRes.value.data)
            ? logsRes.value.data
            : [];

    const devices =
        iotRes.status === "fulfilled" && Array.isArray(iotRes.value.data)
            ? iotRes.value.data
            : [];

    const blockchainLogs =
        blockchainRes.status === "fulfilled" && Array.isArray(blockchainRes.value.data)
            ? blockchainRes.value.data
            : [];

    const errors = logs.filter((x) =>
        JSON.stringify(x).toLowerCase().includes("error")
    ).length;

    const onlineDevices = devices.filter((d) => {
        if (!d.lastUpdated) return false;
        return Date.now() - new Date(d.lastUpdated).getTime() < 2 * 60 * 1000;
    }).length;

    return {
        apiStatus: "Online",
        databaseStatus: "Online",
        websocketStatus: "Active",
        jwtService: "Active",
        encryptionService: "Active",
        aiEngine: "Active",
        backgroundServices: "Running",
        sslStatus: "Valid",
        uptime: "Operational",
        errorRate: errors,
        systemLogs: logs.length,
        iotOnline: onlineDevices,
        iotTotal: devices.length,
        blockchainEvents: blockchainLogs.length,
        cpuUsage: 24,
        memoryUsage: 48,
        diskUsage: 36,
    };
};

export default {
    getSystemHealthData,
};